module.exports = __webpack_public_path__ + "static/img/0006.1b023aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/0006.png
// module id = aNUl
// module chunks = 1